export const ALIEN_NPC_TEXTURES = {
  alienScout: "/assets/combat/alien-scout.png",
  alienArtillery: "/assets/combat/alien-artillery.png",
  alienDisruptor: "/assets/combat/alien-disruptor.png",
} as const;

export type NpcTextureKey =
  | "raider"
  | "sniper"
  | "minelayer"
  | "enemyHeavy"
  | "support"
  | "enemy"
  | "elite"
  | "boss"
  | "transport"
  | keyof typeof ALIEN_NPC_TEXTURES;
export function npcAppearance(archetype: string): {
  texture: NpcTextureKey;
  length: number;
} {
  switch (archetype) {
    case "raider":
      return { texture: "raider", length: 58 };
    case "sniper":
      return { texture: "sniper", length: 88 };
    case "minelayer":
      return { texture: "minelayer", length: 100 };
    case "charger":
      return { texture: "enemyHeavy", length: 78 };
    case "support":
      return { texture: "support", length: 86 };
    case "disruptor":
      return { texture: "enemy", length: 70 };
    case "elite":
      return { texture: "elite", length: 120 };
    case "boss":
      return { texture: "boss", length: 190 };
    case "transport":
      return { texture: "transport", length: 150 };
    case "alien-scout":
      return { texture: "alienScout", length: 58 };
    case "alien-artillery":
      return { texture: "alienArtillery", length: 88 };
    case "alien-disruptor":
      return { texture: "alienDisruptor", length: 70 };
    default:
      return { texture: "raider", length: 58 };
  }
}
